/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksUpdate } from "../../funcs/webhooksUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PutApiLeadScraperMicroserviceApiV1WebhooksRequestBody$inboundSchema,
};

export const tool$webhooksUpdate: ToolDefinition<typeof args> = {
  name: "webhooks_update",
  description: `Update webhook

Updates an existing webhook configuration`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
